<div class="content-grid-parc">
    <div class="main-column">
        <app-parc-resume />
        <app-parc-graphe-production />
        <app-parc-production-cumulee />
    </div>

    <div class="panel side-panel">
        <app-parc-liste-parcs [parcs]="parcs()" />

        <app-parc-installations-par-types />

        <app-parc-contacts />
    </div>
</div>
